import React from 'react'
import { NavLink } from 'react-router-dom'
import { MdShoppingCart } from "react-icons/md";
import { useSelector } from 'react-redux';

const Navbar = () => {

    const {cart}=useSelector((state)=>state)
  return (
    <div>
        <nav className='flex justify-between items-center h-18 max-w-6xl mx-auto'>

        <NavLink to="/">
            <div className='ml-5'>
                <img src="../logo.png" className='h-14'/>
            </div>
        </NavLink>
        <div className='flex items-center font-medium text-slate-100 mr-5 space-x-6'>
        <NavLink to="/">
            <div>
                <p>Home</p>
            </div>
        </NavLink>
        <NavLink to="/cart">
            <div className='relative '>
            <MdShoppingCart className='text-2xl  ' /> 
            {
                cart.length > 0 &&
            <span className='absolute -top-2 -right-2 bg-green-600 w-4 h-4 text-xs
            flex justify-center items-center animate-bounce rounded-full text-white'>{cart.length}</span>
              }
            </div>

        </NavLink>
           
           </div>
           </nav>
    </div>
  )
}

export default Navbar